import * as React from 'react'

import css from './PopoversLayer.css'

type Props = {
  children: React.ReactNode
  style?: React.CSSProperties
  [key: string]: any
}

export default function PopoversLayer({children, style, ...props}: Props) {
  return (
    <div
      {...props}
      className={css.PopoversLayer}
      style={style}
      // we use data-layer attribute to check if click event comes from PopoversLayer
      // see packages/@base-core/email-composer/src/ui/RecipientsSection.tsx
      data-layer="popovers-layer"
    >
      {children}
    </div>
  )
}
